import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasPermission } from "../utils/permissions";

const ProtectedRoute = ({ element, permission, onlyEmail }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  // 🔒 Verifica login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 🔐 Restricción por email (super admin)
  if (onlyEmail && user?.email !== onlyEmail) {
    return <Navigate to="/dashboard" replace />;
  }

  // 🔑 Restricción por permisos
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

export default ProtectedRoute;
